module.exports = __webpack_public_path__ + "img/shop_bg6.0d7cb93e.png";